"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var memoize_1 = __importDefault(require("lodash/memoize"));
var parse_1 = __importDefault(require("date-fns/parse"));
var resolve_locale_code_1 = require("../utils/resolve-locale-code");
var formatterOpts = {
    hour: '2-digit',
    minute: '2-digit'
};
var getFormatter = memoize_1.default(function (code) {
    try {
        if (Intl.DateTimeFormat.supportedLocalesOf([code]).length) {
            return Intl.DateTimeFormat(code, formatterOpts);
        }
        else {
            return Intl.DateTimeFormat('en-US', formatterOpts);
        }
    }
    catch (error) {
        return Intl.DateTimeFormat('en-US', formatterOpts);
    }
});
function formatTime(locale, value) {
    var code = resolve_locale_code_1.resolveLocaleCode(locale);
    var dateTime = value instanceof Date ? value : parse_1.default(value);
    var formatter = getFormatter(code);
    return formatter.format(dateTime);
}
exports.default = formatTime;
//# sourceMappingURL=format-time.js.map